// extracted by mini-css-extract-plugin
export var messageSideLeft = "_nc-1";
export var messageSideRight = "_nc-2";
export var subscribeToBackInStockBubbleContainer = "_nc-0";